<script>
import { h } from "vue";

const TemplateCompiler = (props, context) => {
  return h(props.template, context.attrs, context.slots)
}

export default TemplateCompiler;
</script>
